import { createOdooForm } from '../../actions/odooFormActions';
import Loading from '../common/Loading';
import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

/**
 * Accepts a form type as part of the URL, and attempts to create a form of that type and redirect the user to the form.
 *
 * Intended as a URL target for the end of the 'self assessment' tool.  If the user is logged in, will create a form;
 * if the user isn't, will redirect to the login screen with a redirect to create this form type.
 *
 * Note that if the user then opts to register, the register form will extract this redirect from the URL and pass it to
 * Odoo as a form parameter, enabling Odoo to create the correct type of form.
 */
const CreateForm = ({ sessionId, allowedFormTypes, createOdooForm, token: tokenProp }) => {
  const createStartedRef = useRef(false);
  const navigate = useNavigate();
  const { token: tokenParam } = useParams();
  const token = tokenProp || tokenParam;

  useEffect(() => {
    if (createStartedRef.current) return;

    // Check for matching form type in user's token list
    if (allowedFormTypes.indexOf(token) !== -1) {
      createStartedRef.current = true;
      createOdooForm(sessionId, token, { push: navigate }, (formType = null, formId = null) => {
        if (formType !== null && formId !== null) {
          navigate(`/form/${formType}/${formId}`);
          return;
        }
        if (formType !== null) {
          navigate(`/forms/${formType}`);
          return;
        }
        navigate('/');
      });
    }
  }, [token, allowedFormTypes, sessionId, createOdooForm, navigate]);

  return <Loading text="Creating form..." />;
};

const mapStateToProps = (state) => {
  let allowedFormTypes = [];
  if (state.dashboard.tiles && Array.isArray(state.dashboard.tiles)) {
    for (let i = 0, ii = state.dashboard.tiles.length; i < ii; i++) {
      if (!state.dashboard.tiles[i] || !state.dashboard.tiles[i].formTypes) continue;
      for (let j = 0, jj = state.dashboard.tiles[i].formTypes.length; j < jj; j++) {
        if (state.dashboard.tiles[i].formTypes[j] && state.dashboard.tiles[i].formTypes[j].id) {
          allowedFormTypes.push(state.dashboard.tiles[i].formTypes[j].id);
        }
      }
    }
  }
  return {
    allowedFormTypes,
    sessionId: state.user.sessionId,
  };
};

const mapDispatchToProps = {
  createOdooForm,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateForm);
